import * as types from './mutation-types';

export default {
  [types.SET_PAYMENT_COLLECTION](state, payload) {
    state.paymentCollection = payload;
  },
};
